import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

// Scroll restorer + floating "back to top" button
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-to-top"
      aria-label="Back to top"
      className="fixed bottom-6 left-6 z-40 w-12 h-12 rounded-full bg-[#0F172A] dark:bg-[#F59E0B] text-white dark:text-[#0F172A] shadow-2xl flex items-center justify-center hover:scale-110 transition-transform"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
